import { BrowserRouter as Router, Route } from 'react-router-dom';
import { Helmet } from 'react-helmet-async';

import App2 from './App2';
import Aboutminatechnologies from './components/Aboutminatechnologies2';
import Servicesminatechnologies from './components/Servicesminatechnologies2';
import Whyus from './components/Whyus2';
import Teams from './components/Teams';
import Portfolio from './components/Portfolio';
import Security from './components/Security';
import Contactus from './components/Contactus';

import "./App.css"

// Standalone section pages keep their own SEO tags.
const withMeta = (Component, meta) => () => (
  <>
    {meta && (
      <Helmet>
        <title>{meta.title}</title>
        <meta property="title" content={meta.ogTitle} />
        <meta name="description" content={meta.description} />
        <link rel="canonical" href={meta.canonical}></link>
      </Helmet>
    )}
    <Component />
  </>
);

const AboutPage = withMeta(Aboutminatechnologies, {
  title: 'about mina technologies',
  ogTitle: 'About Us - Mina Technologies',
  description: 'Learn more about Mina Technologies, our mission, vision, and the dedicated team driving innovation in the tech industry.',
  canonical: '/about',
});

const ServicesPage = withMeta(Servicesminatechnologies, {
  title: 'services- mina technologies',
  ogTitle: 'Our Services - Mina Technologies',
  description: 'Explore our expertise in UI/UX design, website development, and mobile app creation. We craft innovative solutions tailored to your needs.',
  canonical: '/service',
});

const WhyusPage = withMeta(Whyus, {
  title: 'why choose mina technologies',
  ogTitle: 'Why Choose Mina Technologies',
  description: 'Choose Mina Technologies for our expertise in UI/UX, web, and mobile app development. We deliver innovative, tailored solutions for your unique needs.',
  canonical: '/whyus',
});

function App() {
  return (
    <Router>
      <Route exact path={"/service"} component={ServicesPage}></Route>
      <Route exact path={"/about"} component={AboutPage}></Route>
      <Route exact path={"/whyus"} component={WhyusPage}></Route>
      <Route exact path={"/team"} component={Teams}></Route>
      <Route exact path={"/portfolio"} component={Portfolio}></Route>
      <Route exact path={"/security"} component={Security}></Route>
      <Route exact path={"/contactus"} component={Contactus}></Route>

      <Route exact path={"/"} component={App2}></Route>
    </Router>
  );
}

export default App;
